import type { TCreditFormCommonFields } from 'entities/creditForm';

export class Birth {
  // eslint-disable-next-line no-empty-function
  constructor(private readonly birth: Pick<Partial<TCreditFormCommonFields>, 'birthDate' | 'birthPlace'>) {}

  map() {
    return {
      birthDate: this.birth?.birthDate || '',
      birthPlace: this.birth?.birthPlace || '',
    };
  }
}
